// Spool table draft state — converters between API DTO, form
// draft, and API input.
import type {
  SpoolInputT,
  SpoolStatus,
} from "../../../../../../shared/types/production-schedule";

export interface SpoolDraft extends SpoolInputT {
  // localKey stays stable across renders even when no DB id exists.
  localKey: string;
}

export function newDraft(sortOrder: number): SpoolDraft {
  return {
    localKey: `new-${Math.random().toString(36).slice(2, 10)}`,
    num: "",
    description: "",
    hours: 0,
    cutStart: null,
    cutDone: null,
    weldStart: null,
    weldDone: null,
    dueDate: null,
    status: "pending",
    sortOrder,
  };
}

export function spoolFromDto(s: {
  id: number;
  num: string;
  description: string | null;
  hours: number;
  cutStart: string | null;
  cutDone: string | null;
  weldStart: string | null;
  weldDone: string | null;
  dueDate: string | null;
  status: SpoolStatus;
  sortOrder: number;
}): SpoolDraft {
  return {
    localKey: `db-${s.id}`,
    id: s.id,
    num: s.num,
    description: s.description,
    hours: s.hours,
    cutStart: s.cutStart,
    cutDone: s.cutDone,
    weldStart: s.weldStart,
    weldDone: s.weldDone,
    dueDate: s.dueDate,
    status: s.status,
    sortOrder: s.sortOrder,
  };
}

export function spoolToInput(s: SpoolDraft, idx: number): SpoolInputT {
  const out: SpoolInputT = {
    num: s.num,
    description: s.description,
    hours: s.hours,
    cutStart: s.cutStart,
    cutDone: s.cutDone,
    weldStart: s.weldStart,
    weldDone: s.weldDone,
    dueDate: s.dueDate,
    status: s.status,
    sortOrder: idx,
  };
  if (s.id) out.id = s.id;
  return out;
}
